import React from "react";
import propTypes from "prop-types";

const ValidatedInput = ({
  input,
  label,
  wrapperClass,
  inputClassName,
  placeholder,
  disabled,
  meta: { error, submitError, touched },
}) => {
  const handleWrapperClass = (error, touched) => {
    if (error && touched) {
      return "fin-col fin-error";
    } else {
      return wrapperClass || "fin-col";
    }
  };

  return (
    <div className={handleWrapperClass(error || submitError, touched)}>
      <label>{label}</label>
      <input
        {...input}
        className={inputClassName}
        disabled={disabled}
        placeholder={placeholder}
      />
      {(error || submitError) && touched && (
        <p className="text-left text-error">{error || submitError}</p>
      )}
    </div>
  );
};

ValidatedInput.propTypes = {
  input: propTypes.object,
  wrapperClass: propTypes.string,
  inputClassName: propTypes.string,
  value: propTypes.string,
  placeholder: propTypes.string,
  disabled: propTypes.bool,
  label: propTypes.string,
  meta: propTypes.object,
};
export default ValidatedInput;
